import styled from "styled-components"

export const Info = styled.div`
    grid-column: span 3;
    grid-row-end: span 2;
    display:flex;
    flex-direction:column;
    margin-bottom:56px;
`
export const Language = styled.div`
    margin-top:24px;
    display:flex;
    align-items:center;
    color:#fff;
`

export const Social = styled.div`
    margin-top:24px;
    display:flex;
    align-items:center;
`

export const SocialIcon = styled.img`
    display:block;
    padding-right: 20px;
`